import require$$0, { useState, useEffect, useCallback } from "react";
import { create } from "zustand";
const BRAND_COLOR = "#272A33";
const BRAND_FONT = '"IQOSW04-Regular", Sans-serif';
const chatbotOptionDiv = {
  textAlign: "center",
  margin: "auto"
};
const brandMessageBubbleColorsBW = (bgColor) => ({
  Bubble: {
    background: "#34303d",
    fontColor: "#fffdfb",
    padding: "6px 6px 3px 2px",
    margin: "16px 5px 13px 3px !important",
    borderRadius: "10px !important",
    fontFamily: BRAND_FONT
  },
  Avatar: {
    background: bgColor
  },
  Header: {
    color: "#D3D3D3",
    margin: "0 3px 5px 0",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.43",
    letterSpacing: "normal",
    fontFamily: BRAND_FONT,
    textAlign: "left",
    "&:first-of-type": {
      ">div": {
        fontSize: "11px",
        fontWeight: "300"
      }
    }
  }
});
const brandMessageBubbleColorsOtherBW = (bgColor) => ({
  Bubble: {
    background: "#e5e5e5",
    fontColor: "#000000",
    padding: "6px 6px 3px 2px",
    margin: "16px 2px 3px 2px !important",
    borderRadius: "10px !important",
    fontFamily: BRAND_FONT
  },
  Avatar: {
    background: bgColor
  },
  Header: {
    color: "#000000",
    margin: "0 3px 5px 0",
    fontWeight: "300",
    fontStretch: "normal",
    fontFamily: BRAND_FONT,
    fontStyle: "normal",
    lineHeight: "1.43",
    letterSpacing: "normal",
    textAlign: "left",
    "&:first-of-type": {
      ">div": {
        fontSize: "11px",
        fontWeight: "300"
      }
    }
  }
});
const dce2BrandWorldDesign = {
  Chat: {
    MessageListItem: {
      FromMe: brandMessageBubbleColorsBW(BRAND_COLOR),
      FromOthers: brandMessageBubbleColorsOtherBW(BRAND_COLOR)
    },
    MessageInput: {
      Button: {
        background: BRAND_COLOR
      }
    },
    MessageCanvasTray: {
      Container: {
        background: "#34303d",
        color: "#fffdfb",
        fontSize: "12px",
        fontFamily: BRAND_FONT,
        padding: "10px 0 0",
        textAlign: "left"
      },
      Button: {
        background: "#ffffff",
        color: "#000000",
        borderRadius: "24px",
        margin: "16px 66px 28px 56px !important",
        padding: "10px 15px 25px 15px",
        fontFamily: BRAND_FONT,
        "&:hover": {
          background: "#00d2d2",
          color: "#000000"
        },
        "&:focus": {
          backgroundColor: "#00d2d2",
          color: "#000000"
        }
      }
    }
  },
  Progress: {
    Circular: {
      animatingForegroundBorderColor: "#00d2d2"
    }
  },
  EntryPoint: {
    Container: {
      display: "none !important"
    }
  },
  MainContainer: {
    zIndex: 1200,
    borderRadius: "1.5em"
  },
  PreEngagementCanvas: {
    Container: {
      color: "#34303d",
      fontWeight: "bold",
      textTransform: "none",
      fontStretch: "normal",
      fontStyle: "normal",
      letterSpacing: "normal",
      lineHeight: "1.3",
      fontFamily: BRAND_FONT,
      "&:first-of-type": {
        ">div": {
          fontSize: "20px"
        }
      }
    },
    Footer: {},
    Form: {
      SubmitButton: {
        background: "#34303d",
        fontSize: "13px",
        borderRadius: "24px",
        color: "white",
        transition: "all .2s",
        textTransform: "none",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "normal",
        letterSpacing: "normal",
        textAlign: "center",
        height: "30px",
        margin: "150px 65px 5px 65px",
        padding: "5px 27px",
        gap: "10px",
        "&:disabled": {
          border: "solid 1.5px #262a33",
          backgroundColor: "#ffffff",
          color: "#34303d"
        },
        "&:hover": {
          backgroundColor: "#00d1d2",
          color: "#34303d"
        },
        "&:focus": {
          backgroundColor: "#00d2d2",
          color: "#34303d"
        }
      },
      Label: {
        fontWeight: "normal",
        fontSize: "12px",
        margin: "5px 4px 13px 0",
        lineHeight: "1.43"
      }
    }
  }
};
const getTimeZone = (market) => {
  let timezone = "";
  switch (market) {
    case "de":
      timezone = "Europe/Berlin";
      break;
    case "fr":
      timezone = "Europe/Paris";
      break;
    case "mx":
      timezone = "America/Mexico City";
      break;
    case "ph":
      timezone = "Asia/Manila";
      break;
    default:
      timezone = "Europe/Berlin";
      break;
  }
  return timezone;
};
const preEngagementConfig = {
  description: "",
  fields: [
    {
      label: "",
      type: "TextareaItem",
      attributes: {
        name: "aiBotInputName",
        type: "text",
        placeholder: "",
        required: false,
        readOnly: true,
        rows: 4
      }
    }
  ],
  footerLabel: "",
  submitLabel: "",
  inputTextDisabledReason: "",
  endChatTextDisabledReason: ""
};
const transformConfig = (config) => {
  const { market, timezone } = config;
  const newConfig = {
    ...config,
    preEngagementSetting: preEngagementConfig,
    market: market.toUpperCase(),
    timezone: timezone || getTimeZone(market)
  };
  return newConfig;
};
const defaultUserId = "anonymous";
const defaultMarketConfig = Object.freeze({
  accountSid: "",
  flexFlowSid: "",
  runtimeDomain: "",
  liveChatEnabled: false,
  language: "",
  market: "",
  channel: "chat",
  timezone: "",
  friendlyName: "Anonymous",
  userID: defaultUserId,
  counterConsumerIndex: 0,
  scrollFocusRequired: true,
  websiteOrigin: "IQOS",
  preEngagementSetting: preEngagementConfig,
  isRTL: false,
  pageEntry: "Default",
  proactiveChatInitialized: false,
  messageButtons: "",
  fiveStarsRating: false,
  openingHoursThrottle: 1,
  noCache: false,
  enableLogs: false,
  twilioScript: "https://assets.flex.twilio.com/releases/flex-webchat-ui/2.9.1/twilio-flex-webchat.min.js",
  containerOffset: "2em",
  productBrandFamily: "IQOS"
});
const CHAT_ACTIVE_KEY = "chat-open";
const TWILIO_MESSAGE_BUBBLE_CLASSNAME = "Twilio-MessageBubble-default";
const TWILIO_ATTACH_FILE_BUTTON_CLASSNAME = "Twilio-AttachFileButton";
const fetchUrl = (url, body, headers) => fetch(url, {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    ...headers
  },
  body: typeof body === "object" ? JSON.stringify(body) : body
}).then((response) => {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}).catch((err) => {
  throw err;
});
const loadScript = (url) => new Promise((resolve, reject) => {
  try {
    const script = document.createElement("script");
    script.setAttribute("data-testid", "chat-script");
    script.src = url;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      reject("Failed to load twilio script");
    };
    document.head.appendChild(script);
  } catch (err) {
    reject(err.message);
  }
});
let chatInstance = null;
const getChatInstance = () => chatInstance;
const setChatInstance = (instance) => {
  chatInstance = instance;
};
const addLocalizationToMessageButtons = (pageEntry, localization2) => {
  switch (pageEntry) {
    case "Trade-In":
      return {
        options: {
          1: `${localization2.PredefinedChatMessagePageEntry1Button1}`,
          2: `${localization2.PredefinedChatMessagePageEntry1Button2}`
        },
        type: "optionSelection"
      };
    case "Registration":
      return {
        options: {
          1: `${localization2.PredefinedChatMessagePageEntry2Button1}`,
          2: `${localization2.PredefinedChatMessagePageEntry2Button2}`
        },
        type: "optionSelection"
      };
    case "Checkout":
      return {
        options: {
          1: `${localization2.PredefinedChatMessagePageEntry3Button1}`,
          2: `${localization2.PredefinedChatMessagePageEntry3Button2}`
        },
        type: "optionSelection"
      };
    case "Default":
    default:
      return void 0;
  }
};
const mapLocalization = (marketConfig, appConfig, localization2) => {
  const { friendlyName, userID, pageEntry, liveChatEnabled } = marketConfig;
  const {
    timezone,
    chatbotName,
    PreEngagementTextBody: placeholder,
    PreEngagementWelcomeMessage,
    PreEngagementFooterLabel: footerLabel,
    PreEngagementSubmitLabel: submitLabel
  } = localization2;
  const preEngagementConfig2 = liveChatEnabled ? appConfig.preEngagementConfig : {
    inputTextDisabledReason: void 0,
    description: userID !== "anonymous" ? PreEngagementWelcomeMessage.replace(
      "%USER_NAME%",
      ` ${friendlyName}`
    ) : PreEngagementWelcomeMessage.replace("%USER_NAME%", ""),
    fields: [
      {
        label: "",
        type: "TextareaItem",
        attributes: {
          name: "aiBotInputName",
          type: "text",
          placeholder,
          required: false,
          readOnly: true,
          rows: 4
        }
      }
    ],
    footerLabel,
    submitLabel
  };
  return {
    ...appConfig,
    preEngagementConfig: preEngagementConfig2,
    context: {
      ...appConfig.context,
      timezone,
      chatbotName,
      messageButtons: addLocalizationToMessageButtons(
        pageEntry,
        localization2
      )
    }
  };
};
const addOriginToContent = (localization2, websiteOrigin, pageEntry) => {
  const newLocalization = localization2;
  newLocalization.PredefinedChatMessageAuthorName = localization2.PredefinedChatMessageAuthorName ? localization2.PredefinedChatMessageAuthorName.replace(
    /%BrandFamily%/g,
    websiteOrigin
  ) : "";
  newLocalization.author = localization2.author ? localization2.author.replace(/%BrandFamily%/g, websiteOrigin) : "";
  newLocalization.PredefinedChatMessageBody = localization2.PredefinedChatMessageBody ? localization2.PredefinedChatMessageBody.replace(
    /%BrandFamily%/g,
    websiteOrigin
  ) : "";
  newLocalization.WelcomeMessage = localization2.WelcomeMessage ? localization2.WelcomeMessage.replace(/%BrandFamily%/g, websiteOrigin) : "";
  newLocalization.welcomeMessage = localization2.welcomeMessage ? localization2.welcomeMessage.replace(/%BrandFamily%/g, websiteOrigin) : "";
  newLocalization.DefaultPredefinedChatMessageBody = localization2.PredefinedChatMessageBody && localization2.PredefinedChatMessageBody.replace(
    /%BrandFamily%/g,
    websiteOrigin
  );
  switch (pageEntry) {
    case "Trade-In":
      newLocalization.PredefinedChatMessageBody = localization2.PredefinedChatMessageBodyPageEntry1 && localization2.PredefinedChatMessageBodyPageEntry1.replace(
        /%BrandFamily%/g,
        websiteOrigin
      );
      Twilio.FlexWebChat.MessagingCanvas.defaultProps.showWelcomeMessage = false;
      break;
    case "Registration":
      newLocalization.PredefinedChatMessageBody = localization2.PredefinedChatMessageBodyPageEntry2 && localization2.PredefinedChatMessageBodyPageEntry2.replace(
        /%BrandFamily%/g,
        websiteOrigin
      );
      Twilio.FlexWebChat.MessagingCanvas.defaultProps.showWelcomeMessage = false;
      break;
    case "Checkout":
      newLocalization.PredefinedChatMessageBody = localization2.PredefinedChatMessageBodyPageEntry3 && localization2.PredefinedChatMessageBodyPageEntry3.replace(
        /%BrandFamily%/g,
        websiteOrigin
      );
      Twilio.FlexWebChat.MessagingCanvas.defaultProps.showWelcomeMessage = false;
      break;
    case "Default":
    default:
      newLocalization.PredefinedChatMessageBody = localization2.PredefinedChatMessageBody && localization2.PredefinedChatMessageBody.replace(
        /%BrandFamily%/g,
        websiteOrigin
      );
      break;
  }
  return newLocalization;
};
const addLocalizationToManager = (localization2) => {
  const { manager } = getChatInstance();
  if (localization2) {
    Object.keys(localization2).forEach((key) => {
      if (key in manager.strings) {
        manager.strings[key] = localization2[key];
      }
    });
  }
};
var ChatOpenState = /* @__PURE__ */ ((ChatOpenState2) => {
  ChatOpenState2["CLOSED"] = "closed";
  ChatOpenState2["OPEN"] = "open";
  return ChatOpenState2;
})(ChatOpenState || {});
const setChatOpen = (state) => {
  sessionStorage.setItem(CHAT_ACTIVE_KEY, state);
};
const getChatOpen = () => sessionStorage.getItem(CHAT_ACTIVE_KEY);
const useSessionStorage = () => {
  const [isChatOpen, setIsChatOpen] = useState(false);
  useEffect(() => {
    setIsChatOpen(
      getChatOpen() === "open"
      /* OPEN */
    );
  }, []);
  return { isChatOpen };
};
const storageKey = "working-hours-check";
const getWorkingHoursFromSessionStorage = () => {
  const val = sessionStorage.getItem(storageKey);
  if (val) {
    return JSON.parse(val);
  }
  return null;
};
const setWorkingHoursSessionStorage = (resp) => {
  sessionStorage.setItem(storageKey, JSON.stringify(resp));
};
let loggerEnabled = defaultMarketConfig.enableLogs;
const getConfig = (marketConfigOverride) => {
  let marketConfig = {
    ...defaultMarketConfig,
    ...marketConfigOverride
  };
  marketConfig = transformConfig(marketConfig);
  const {
    market,
    language,
    friendlyName,
    websiteOrigin,
    accountSid,
    channel,
    flexFlowSid,
    userID,
    preEngagementSetting,
    runtimeDomain,
    liveChatEnabled,
    containerOffset
  } = marketConfig;
  const isOpen = getChatOpen();
  const appConfig = {
    accountSid,
    flexFlowSid,
    disableLocalStorage: false,
    startEngagementOnInit: liveChatEnabled,
    preEngagementConfig: preEngagementSetting,
    fileAttachment: {
      enabled: true
    },
    componentProps: {
      MainContainer: { bottom: containerOffset }
    },
    context: {
      market,
      channel,
      language,
      interactionTool: "livechat",
      friendlyName,
      userID,
      useLiveChat: liveChatEnabled,
      websiteOrigin,
      runtimeDomain,
      proactiveChatInitialized: isOpen
    },
    colorTheme: {
      overrides: dce2BrandWorldDesign
    }
  };
  loggerEnabled = marketConfigOverride.enableLogs;
  return { appConfig, marketConfig };
};
const getIsLoggerEnabled = () => loggerEnabled;
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min)
    return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var f = require$$0, k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = { key: true, ref: true, __self: true, __source: true };
  function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for (b in a)
      m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps)
      for (b in a = c.defaultProps, a)
        void 0 === d[b] && (d[b] = a[b]);
    return { $$typeof: k, type: c, key: e, ref: h, props: d, _owner: n.current };
  }
  reactJsxRuntime_production_min.Fragment = l;
  reactJsxRuntime_production_min.jsx = q;
  reactJsxRuntime_production_min.jsxs = q;
  return reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development)
    return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var React = require$$0;
      var REACT_ELEMENT_TYPE = Symbol.for("react.element");
      var REACT_PORTAL_TYPE = Symbol.for("react.portal");
      var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
      var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
      var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
      var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
      var REACT_CONTEXT_TYPE = Symbol.for("react.context");
      var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
      var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
      var REACT_MEMO_TYPE = Symbol.for("react.memo");
      var REACT_LAZY_TYPE = Symbol.for("react.lazy");
      var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
      var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") {
          return null;
        }
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") {
          return maybeIterator;
        }
        return null;
      }
      var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function error(format) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning("error", format, args);
          }
        }
      }
      function printWarning(level, format, args) {
        {
          var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame2.getStackAddendum();
          if (stack !== "") {
            format += "%s";
            args = args.concat([stack]);
          }
          var argsWithFormat = args.map(function(item) {
            return String(item);
          });
          argsWithFormat.unshift("Warning: " + format);
          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }
      var enableScopeAPI = false;
      var enableCacheElement = false;
      var enableTransitionTracing = false;
      var enableLegacyHidden = false;
      var enableDebugTracing = false;
      var REACT_MODULE_REFERENCE;
      {
        REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
      }
      function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") {
          return true;
        }
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
          return true;
        }
        if (typeof type === "object" && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
          // types supported by any Flight configuration anywhere since
          // we don't know which Flight build this will end up being used
          // with.
          type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== void 0) {
            return true;
          }
        }
        return false;
      }
      function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) {
          return displayName;
        }
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
      }
      function getContextName(type) {
        return type.displayName || "Context";
      }
      function getComponentNameFromType(type) {
        if (type == null) {
          return null;
        }
        {
          if (typeof type.tag === "number") {
            error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
          }
        }
        if (typeof type === "function") {
          return type.displayName || type.name || null;
        }
        if (typeof type === "string") {
          return type;
        }
        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return "Fragment";
          case REACT_PORTAL_TYPE:
            return "Portal";
          case REACT_PROFILER_TYPE:
            return "Profiler";
          case REACT_STRICT_MODE_TYPE:
            return "StrictMode";
          case REACT_SUSPENSE_TYPE:
            return "Suspense";
          case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              var context = type;
              return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
              var provider = type;
              return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
              var outerName = type.displayName || null;
              if (outerName !== null) {
                return outerName;
              }
              return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                return getComponentNameFromType(init(payload));
              } catch (x) {
                return null;
              }
            }
          }
        }
        return null;
      }
      var assign = Object.assign;
      var disabledDepth = 0;
      var prevLog;
      var prevInfo;
      var prevWarn;
      var prevError;
      var prevGroup;
      var prevGroupCollapsed;
      var prevGroupEnd;
      function disabledLog() {
      }
      disabledLog.__reactDisabledLog = true;
      function disableLogs() {
        {
          if (disabledDepth === 0) {
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd;
            var props = {
              configurable: true,
              enumerable: true,
              value: disabledLog,
              writable: true
            };
            Object.defineProperties(console, {
              info: props,
              log: props,
              warn: props,
              error: props,
              group: props,
              groupCollapsed: props,
              groupEnd: props
            });
          }
          disabledDepth++;
        }
      }
      function reenableLogs() {
        {
          disabledDepth--;
          if (disabledDepth === 0) {
            var props = {
              configurable: true,
              enumerable: true,
              writable: true
            };
            Object.defineProperties(console, {
              log: assign({}, props, {
                value: prevLog
              }),
              info: assign({}, props, {
                value: prevInfo
              }),
              warn: assign({}, props, {
                value: prevWarn
              }),
              error: assign({}, props, {
                value: prevError
              }),
              group: assign({}, props, {
                value: prevGroup
              }),
              groupCollapsed: assign({}, props, {
                value: prevGroupCollapsed
              }),
              groupEnd: assign({}, props, {
                value: prevGroupEnd
              })
            });
          }
          if (disabledDepth < 0) {
            error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
          }
        }
      }
      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
      var prefix;
      function describeBuiltInComponentFrame(name, source, ownerFn) {
        {
          if (prefix === void 0) {
            try {
              throw Error();
            } catch (x) {
              var match = x.stack.trim().match(/\n( *(at )?)/);
              prefix = match && match[1] || "";
            }
          }
          return "\n" + prefix + name;
        }
      }
      var reentry = false;
      var componentFrameCache;
      {
        var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
        componentFrameCache = new PossiblyWeakMap();
      }
      function describeNativeComponentFrame(fn, construct) {
        if (!fn || reentry) {
          return "";
        }
        {
          var frame = componentFrameCache.get(fn);
          if (frame !== void 0) {
            return frame;
          }
        }
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var previousDispatcher;
        {
          previousDispatcher = ReactCurrentDispatcher.current;
          ReactCurrentDispatcher.current = null;
          disableLogs();
        }
        try {
          if (construct) {
            var Fake = function() {
              throw Error();
            };
            Object.defineProperty(Fake.prototype, "props", {
              set: function() {
                throw Error();
              }
            });
            if (typeof Reflect === "object" && Reflect.construct) {
              try {
                Reflect.construct(Fake, []);
              } catch (x) {
                control = x;
              }
              Reflect.construct(fn, [], Fake);
            } else {
              try {
                Fake.call();
              } catch (x) {
                control = x;
              }
              fn.call(Fake.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (x) {
              control = x;
            }
            fn();
          }
        } catch (sample) {
          if (sample && control && typeof sample.stack === "string") {
            var sampleLines = sample.stack.split("\n");
            var controlLines = control.stack.split("\n");
            var s = sampleLines.length - 1;
            var c = controlLines.length - 1;
            while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
              c--;
            }
            for (; s >= 1 && c >= 0; s--, c--) {
              if (sampleLines[s] !== controlLines[c]) {
                if (s !== 1 || c !== 1) {
                  do {
                    s--;
                    c--;
                    if (c < 0 || sampleLines[s] !== controlLines[c]) {
                      var _frame = "\n" + sampleLines[s].replace(" at new ", " at ");
                      if (fn.displayName && _frame.includes("<anonymous>")) {
                        _frame = _frame.replace("<anonymous>", fn.displayName);
                      }
                      {
                        if (typeof fn === "function") {
                          componentFrameCache.set(fn, _frame);
                        }
                      }
                      return _frame;
                    }
                  } while (s >= 1 && c >= 0);
                }
                break;
              }
            }
          }
        } finally {
          reentry = false;
          {
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
          }
          Error.prepareStackTrace = previousPrepareStackTrace;
        }
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        {
          if (typeof fn === "function") {
            componentFrameCache.set(fn, syntheticFrame);
          }
        }
        return syntheticFrame;
      }
      function describeFunctionComponentFrame(fn, source, ownerFn) {
        {
          return describeNativeComponentFrame(fn, false);
        }
      }
      function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
      }
      function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) {
          return "";
        }
        if (typeof type === "function") {
          {
            return describeNativeComponentFrame(type, shouldConstruct(type));
          }
        }
        if (typeof type === "string") {
          return describeBuiltInComponentFrame(type);
        }
        switch (type) {
          case REACT_SUSPENSE_TYPE:
            return describeBuiltInComponentFrame("Suspense");
          case REACT_SUSPENSE_LIST_TYPE:
            return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
              return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
              } catch (x) {
              }
            }
          }
        }
        return "";
      }
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var loggedTypeFailures = {};
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame.setExtraStackFrame(null);
          }
        }
      }
      function checkPropTypes(typeSpecs, values, location, componentName, element) {
        {
          var has = Function.call.bind(hasOwnProperty);
          for (var typeSpecName in typeSpecs) {
            if (has(typeSpecs, typeSpecName)) {
              var error$1 = void 0;
              try {
                if (typeof typeSpecs[typeSpecName] !== "function") {
                  var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  err.name = "Invariant Violation";
                  throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (ex) {
                error$1 = ex;
              }
              if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
              }
              if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
              }
            }
          }
        }
      }
      var isArrayImpl = Array.isArray;
      function isArray(a) {
        return isArrayImpl(a);
      }
      function typeName(value) {
        {
          var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
          var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
          return type;
        }
      }
      function willCoercionThrow(value) {
        {
          try {
            testStringCoercion(value);
            return false;
          } catch (e) {
            return true;
          }
        }
      }
      function testStringCoercion(value) {
        return "" + value;
      }
      function checkKeyStringCoercion(value) {
        {
          if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value);
          }
        }
      }
      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
      var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
      };
      var specialPropKeyWarningShown;
      var specialPropRefWarningShown;
      var didWarnAboutStringRefs;
      {
        didWarnAboutStringRefs = {};
      }
      function hasValidRef(config) {
        {
          if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.ref !== void 0;
      }
      function hasValidKey(config) {
        {
          if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.key !== void 0;
      }
      function warnIfStringRefCannotBeAutoConverted(config, self) {
        {
          if (typeof config.ref === "string" && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
              error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);
              didWarnAboutStringRefs[componentName] = true;
            }
          }
        }
      }
      function defineKeyPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
              specialPropKeyWarningShown = true;
              error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingKey.isReactWarning = true;
          Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
          });
        }
      }
      function defineRefPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
              specialPropRefWarningShown = true;
              error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingRef.isReactWarning = true;
          Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
          });
        }
      }
      var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: REACT_ELEMENT_TYPE,
          // Built-in properties that belong on the element
          type,
          key,
          ref,
          props,
          // Record the component responsible for creating this element.
          _owner: owner
        };
        {
          element._store = {};
          Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
          });
          Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
          });
          Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
          });
          if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
          }
        }
        return element;
      };
      function jsxDEV(type, config, maybeKey, source, self) {
        {
          var propName;
          var props = {};
          var key = null;
          var ref = null;
          if (maybeKey !== void 0) {
            {
              checkKeyStringCoercion(maybeKey);
            }
            key = "" + maybeKey;
          }
          if (hasValidKey(config)) {
            {
              checkKeyStringCoercion(config.key);
            }
            key = "" + config.key;
          }
          if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
          }
          for (propName in config) {
            if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
              props[propName] = config[propName];
            }
          }
          if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for (propName in defaultProps) {
              if (props[propName] === void 0) {
                props[propName] = defaultProps[propName];
              }
            }
          }
          if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) {
              defineKeyPropWarningGetter(props, displayName);
            }
            if (ref) {
              defineRefPropWarningGetter(props, displayName);
            }
          }
          return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
        }
      }
      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement$1(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame$1.setExtraStackFrame(null);
          }
        }
      }
      var propTypesMisspellWarningShown;
      {
        propTypesMisspellWarningShown = false;
      }
      function isValidElement(object) {
        {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
      }
      function getDeclarationErrorAddendum() {
        {
          if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name) {
              return "\n\nCheck the render method of `" + name + "`.";
            }
          }
          return "";
        }
      }
      function getSourceInfoErrorAddendum(source) {
        {
          if (source !== void 0) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
          }
          return "";
        }
      }
      var ownerHasKeyUseWarning = {};
      function getCurrentComponentErrorInfo(parentType) {
        {
          var info = getDeclarationErrorAddendum();
          if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) {
              info = "\n\nCheck the top-level render call using <" + parentName + ">.";
            }
          }
          return info;
        }
      }
      function validateExplicitKey(element, parentType) {
        {
          if (!element._store || element._store.validated || element.key != null) {
            return;
          }
          element._store.validated = true;
          var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }
          ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
          var childOwner = "";
          if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
            childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
          }
          setCurrentlyValidatingElement$1(element);
          error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
          setCurrentlyValidatingElement$1(null);
        }
      }
      function validateChildKeys(node, parentType) {
        {
          if (typeof node !== "object") {
            return;
          }
          if (isArray(node)) {
            for (var i = 0; i < node.length; i++) {
              var child = node[i];
              if (isValidElement(child)) {
                validateExplicitKey(child, parentType);
              }
            }
          } else if (isValidElement(node)) {
            if (node._store) {
              node._store.validated = true;
            }
          } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") {
              if (iteratorFn !== node.entries) {
                var iterator = iteratorFn.call(node);
                var step;
                while (!(step = iterator.next()).done) {
                  if (isValidElement(step.value)) {
                    validateExplicitKey(step.value, parentType);
                  }
                }
              }
            }
          }
        }
      }
      function validatePropTypes(element) {
        {
          var type = element.type;
          if (type === null || type === void 0 || typeof type === "string") {
            return;
          }
          var propTypes;
          if (typeof type === "function") {
            propTypes = type.propTypes;
          } else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          type.$$typeof === REACT_MEMO_TYPE)) {
            propTypes = type.propTypes;
          } else {
            return;
          }
          if (propTypes) {
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
          } else if (type.PropTypes !== void 0 && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true;
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
          }
          if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) {
            error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
          }
        }
      }
      function validateFragmentProps(fragment) {
        {
          var keys = Object.keys(fragment.props);
          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            if (key !== "children" && key !== "key") {
              setCurrentlyValidatingElement$1(fragment);
              error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
              setCurrentlyValidatingElement$1(null);
              break;
            }
          }
          if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
          }
        }
      }
      function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        {
          var validType = isValidElementType(type);
          if (!validType) {
            var info = "";
            if (type === void 0 || typeof type === "object" && type !== null && Object.keys(type).length === 0) {
              info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            }
            var sourceInfo = getSourceInfoErrorAddendum(source);
            if (sourceInfo) {
              info += sourceInfo;
            } else {
              info += getDeclarationErrorAddendum();
            }
            var typeString;
            if (type === null) {
              typeString = "null";
            } else if (isArray(type)) {
              typeString = "array";
            } else if (type !== void 0 && type.$$typeof === REACT_ELEMENT_TYPE) {
              typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
              info = " Did you accidentally export a JSX literal instead of a component?";
            } else {
              typeString = typeof type;
            }
            error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
          }
          var element = jsxDEV(type, props, key, source, self);
          if (element == null) {
            return element;
          }
          if (validType) {
            var children = props.children;
            if (children !== void 0) {
              if (isStaticChildren) {
                if (isArray(children)) {
                  for (var i = 0; i < children.length; i++) {
                    validateChildKeys(children[i], type);
                  }
                  if (Object.freeze) {
                    Object.freeze(children);
                  }
                } else {
                  error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                }
              } else {
                validateChildKeys(children, type);
              }
            }
          }
          if (type === REACT_FRAGMENT_TYPE) {
            validateFragmentProps(element);
          } else {
            validatePropTypes(element);
          }
          return element;
        }
      }
      function jsxWithValidationStatic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, true);
        }
      }
      function jsxWithValidationDynamic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, false);
        }
      }
      var jsx2 = jsxWithValidationDynamic;
      var jsxs2 = jsxWithValidationStatic;
      reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
      reactJsxRuntime_development.jsx = jsx2;
      reactJsxRuntime_development.jsxs = jsxs2;
    })();
  }
  return reactJsxRuntime_development;
}
if (process.env.NODE_ENV === "production") {
  jsxRuntime.exports = requireReactJsxRuntime_production_min();
} else {
  jsxRuntime.exports = requireReactJsxRuntime_development();
}
var jsxRuntimeExports = jsxRuntime.exports;
const Fragment = jsxRuntimeExports.Fragment;
const jsx = jsxRuntimeExports.jsx;
const jsxs = jsxRuntimeExports.jsxs;
const SelectAnswer = (props) => {
  var _a;
  const { message } = props;
  return /* @__PURE__ */ jsx(
    "p",
    {
      style: {
        paddingLeft: "12px",
        paddingRight: "12px",
        paddingBottom: "10px"
      },
      children: (_a = message == null ? void 0 : message.source.attributes) == null ? void 0 : _a.answer
    }
  );
};
const Star = (props) => {
  const { num, onClick } = props;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      "input",
      {
        style: { display: "none" },
        type: "radio",
        className: "stars",
        id: `${num}-star`,
        value: num,
        "data-testid": `${num}-star`,
        onClick: () => onClick(num, `${num}-star`)
      }
    ),
    /* @__PURE__ */ jsx("label", { htmlFor: `${num}-star` })
  ] });
};
const logger = Object.keys(console).reduce((pv, cv) => {
  if (getIsLoggerEnabled()) {
    return {
      ...pv,
      // @ts-expect-error console error
      [cv]: (...args) => console[cv](args)
    };
  }
  return { ...pv, [cv]: () => {
  } };
}, {});
function sendSelectedOption({
  optionValue,
  optionKey,
  message,
  channelSid
}) {
  var _a;
  const { manager } = getChatInstance();
  if (((_a = message.source.state) == null ? void 0 : _a.attributes) && message.source.state.attributes.intentRequired && message.source.state.attributes.intentRequired === true) {
    Twilio.FlexWebChat.Actions.invokeAction("SendMessage", {
      channelSid,
      messageSid: message.source.state.sid,
      body: optionValue,
      messageAttributes: {
        type: "optionAnswer",
        answer: optionValue,
        answerKey: optionKey,
        intent: optionValue
      },
      attributes: message.source.attributes
    }).catch((err) => {
      logger.error(err);
    });
  } else if (message.source.state) {
    Twilio.FlexWebChat.Actions.invokeAction("SendMessage", {
      channelSid,
      messageSid: message.source.state.sid,
      body: optionValue,
      messageAttributes: {
        type: "optionAnswer",
        answer: optionValue,
        answerKey: optionKey
      },
      attributes: message.source.attributes
    }).catch((err) => {
      logger.error(err);
    });
  } else {
    Twilio.FlexWebChat.Actions.invokeAction("SendMessage", {
      channelSid,
      body: optionValue,
      messageAttributes: {
        type: "optionAnswer",
        answer: optionValue,
        answerKey: optionKey
      },
      attributes: message.source.attributes
    }).catch((err) => {
      logger.error(err);
    });
    manager.configuration.context.fiveStarsInitialized = true;
  }
  manager.configuration.context.counterConsumerIndex = document.getElementsByClassName(TWILIO_MESSAGE_BUBBLE_CLASSNAME).length;
}
const SelectFiveStars = (props) => {
  const { channelSid, message } = props;
  const onClick = (number, value) => {
    sendSelectedOption({
      optionKey: value,
      optionValue: number,
      message,
      channelSid
    });
  };
  return /* @__PURE__ */ jsxs("div", { className: "star-rating", children: [
    /* @__PURE__ */ jsx(Star, { num: "5", onClick }),
    /* @__PURE__ */ jsx(Star, { num: "4", onClick }),
    /* @__PURE__ */ jsx(Star, { num: "3", onClick }),
    /* @__PURE__ */ jsx(Star, { num: "2", onClick }),
    /* @__PURE__ */ jsx(Star, { num: "1", onClick })
  ] });
};
const CloseIcon = (props) => {
  const { onClick } = props;
  return /* @__PURE__ */ jsx(
    "button",
    {
      type: "button",
      onClick,
      style: {
        position: "absolute",
        right: "0px",
        top: "0px",
        background: "none",
        border: "0"
      },
      children: /* @__PURE__ */ jsx("svg", { width: "2.5em", height: "2.5em", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx("path", { d: "M15.595 9.216L12.81 12l2.784 2.784a.573.573 0 1 1-.811.811L12 12.81l-2.784 2.784a.573.573 0 1 1-.811-.811L11.19 12 8.405 9.216a.573.573 0 1 1 .811-.811L12 11.19l2.784-2.784a.573.573 0 0 1 .811.811z" }) }, "xButton")
    }
  );
};
const SelectInitialOptions = (props) => {
  var _a;
  const { manager } = getChatInstance();
  const { channelSid, message } = props;
  const onClick = (key) => {
    if (message && channelSid && !manager.configuration.context.messageButtons.isDisabled) {
      sendSelectedOption({
        optionValue: manager.configuration.context.messageButtons.options[key],
        optionKey: key,
        message,
        channelSid
      });
    }
  };
  return manager ? /* @__PURE__ */ jsx("div", { style: chatbotOptionDiv, children: ((_a = manager.configuration.context.messageButtons) == null ? void 0 : _a.options) && Object.keys(manager.configuration.context.messageButtons.options).map(
    (key, index) => /* @__PURE__ */ jsx("p", { children: /* @__PURE__ */ jsx(
      "button",
      {
        className: "chatbot-button",
        type: "button",
        disabled: !!manager.configuration.context.messageButtons.isDisabled,
        onClick: () => onClick(key),
        "data-testid": `option-${index + 1}-button`,
        children: manager.configuration.context.messageButtons.options[key]
      },
      `button-${key}`
    ) }, key)
  ) }) : null;
};
const SelectOptions = (props) => {
  var _a, _b;
  const { message, channelSid } = props;
  const onClick = (key) => {
    var _a2, _b2;
    if (message && channelSid) {
      sendSelectedOption({
        optionValue: (_b2 = (_a2 = message.source.attributes) == null ? void 0 : _a2.options) == null ? void 0 : _b2[key],
        optionKey: key,
        message,
        channelSid
      });
    }
  };
  return /* @__PURE__ */ jsx(
    "div",
    {
      style: {
        textAlign: "center",
        margin: "auto"
      },
      children: ((_b = (_a = message == null ? void 0 : message.source) == null ? void 0 : _a.attributes) == null ? void 0 : _b.options) && Object.keys(message.source.attributes.options).map((key, index) => {
        var _a2, _b2, _c;
        return /* @__PURE__ */ jsx("p", { children: /* @__PURE__ */ jsx(
          "button",
          {
            className: "chatbot-button",
            type: "button",
            disabled: !!((_a2 = message.source.attributes) == null ? void 0 : _a2.isDisabled),
            onClick: () => onClick(key),
            "data-testid": `option-${index + 1}-button`,
            children: (_c = (_b2 = message.source.attributes) == null ? void 0 : _b2.options) == null ? void 0 : _c[key]
          },
          `button-${key}`
        ) }, key);
      })
    }
  );
};
const ButtonLink = ({ message }) => {
  var _a, _b;
  const onClick = () => {
    var _a2, _b2;
    (_b2 = window == null ? void 0 : window.open) == null ? void 0 : _b2.call(window, (_a2 = message == null ? void 0 : message.source.attributes) == null ? void 0 : _a2.buttonLinkURL, "_blank");
  };
  return /* @__PURE__ */ jsx("div", { style: chatbotOptionDiv, children: /* @__PURE__ */ jsx("p", { children: /* @__PURE__ */ jsx(
    "button",
    {
      className: "chatbot-button",
      type: "button",
      disabled: !!((_a = message == null ? void 0 : message.source.attributes) == null ? void 0 : _a.isDisabled),
      onClick,
      "data-testid": "button-link",
      children: (_b = message == null ? void 0 : message.source.attributes) == null ? void 0 : _b.buttonLinkLabel
    },
    "linkButton"
  ) }, "buttonLinkPanel") });
};
const addContent = () => {
  var _a;
  Twilio.FlexWebChat.MessageBubble.Content.add(
    /* @__PURE__ */ jsx(ButtonLink, {}, "buttonLinkKey"),
    {
      if: (props) => props.message.source.attributes && props.message.source.attributes.buttonLinkLabel && props.message.source.attributes.buttonLinkURL
    }
  );
  Twilio.FlexWebChat.MessageBubble.Content.remove("body", {
    if: (props) => {
      var _a2, _b, _c;
      return ((_c = (_b = (_a2 = props == null ? void 0 : props.message) == null ? void 0 : _a2.source) == null ? void 0 : _b.attributes) == null ? void 0 : _c.type) === "optionAnswer";
    }
  });
  Twilio.FlexWebChat.MessageBubble.Content.add(
    /* @__PURE__ */ jsx(SelectAnswer, {}, "select-answer"),
    {
      if: (props) => {
        var _a2, _b, _c;
        return ((_c = (_b = (_a2 = props == null ? void 0 : props.message) == null ? void 0 : _a2.source) == null ? void 0 : _b.attributes) == null ? void 0 : _c.type) === "optionAnswer";
      }
    }
  );
  Twilio.FlexWebChat.MainHeader.Content.replace(
    /* @__PURE__ */ jsx(
      CloseIcon,
      {
        onClick: () => {
          setChatOpen(ChatOpenState.CLOSED);
          Twilio.FlexWebChat.Actions.invokeAction("MinimizeChat").catch(
            (err) => logger.error(err)
          );
        }
      },
      "closeButton"
    )
  );
  const manager = (_a = getChatInstance()) == null ? void 0 : _a.manager;
  Twilio.FlexWebChat.MessageBubble.Content.add(
    /* @__PURE__ */ jsx(SelectInitialOptions, {}, "select-initial-options"),
    {
      if: () => (manager == null ? void 0 : manager.configuration.context.useLiveChat) && !(manager == null ? void 0 : manager.configuration.context.proactiveChatInitialized) && (manager == null ? void 0 : manager.configuration.context.messageButtons)
    }
  );
  Twilio.FlexWebChat.MessageBubble.Content.add(
    /* @__PURE__ */ jsx(SelectOptions, {}, "select-options"),
    {
      if: (props) => {
        var _a2, _b, _c;
        return manager.configuration.context.proactiveChatInitialized && ((_c = (_b = (_a2 = props == null ? void 0 : props.message) == null ? void 0 : _a2.source) == null ? void 0 : _b.attributes) == null ? void 0 : _c.type) === "optionSelection";
      }
    }
  );
  Twilio.FlexWebChat.MessageBubble.Content.add(
    /* @__PURE__ */ jsx(SelectFiveStars, {}, "star-rating"),
    {
      if: (props) => {
        var _a2, _b, _c;
        return ((_c = (_b = (_a2 = props == null ? void 0 : props.message) == null ? void 0 : _a2.source) == null ? void 0 : _b.attributes) == null ? void 0 : _c.fiveStarsRating) && !manager.configuration.context.fiveStarsInitialized;
      }
    }
  );
};
const fetchOpeningHours = (runtimeDomain, details) => fetchUrl(`https://${runtimeDomain}/working-hours-v3`, details).then(
  (response) => response.json()
);
const fetchAibotLocalization = (runtimeDomain, details) => fetchUrl(`https://${runtimeDomain}/getSyncMapItem`, details).then((response) => response.json()).then((d) => d);
const fetchLiveChatLocalization = (runtimeDomain, details) => fetchUrl(`https://${runtimeDomain}/get-dynamic-configs`, details).then(
  async (response) => response.json()
);
const fetchChatMessageAttributes = (runtimeDomain, details) => fetchUrl(`https://${runtimeDomain}/update-chat-massage-attributes`, details, {
  "Content-Type": "application/x-www-form-urlencoded"
});
async function afterSendMessage(payload) {
  const { manager } = getChatInstance();
  const optionButtons = document.querySelectorAll(".chatbot-button");
  const fiveStarsRatingButtons = document.querySelectorAll(".stars");
  let attr = payload.attributes;
  optionButtons.forEach((optionButton) => {
    optionButton.disabled = true;
  });
  fiveStarsRatingButtons.forEach((star) => {
    star.disabled = true;
  });
  if ((attr == null ? void 0 : attr.fiveStarsRating) && !!optionButtons[optionButtons.length - 1]) {
    optionButtons[optionButtons.length - 1].disabled = false;
    Twilio.FlexWebChat.MessageInput.defaultProps.disabledReason = void 0;
  }
  if (manager.configuration.context.scrollFocusRequired) {
    manager.configuration.context.counterConsumerIndex = document.getElementsByClassName(TWILIO_MESSAGE_BUBBLE_CLASSNAME).length - 1;
  }
  if (manager.configuration.context.proactiveChatInitialized && !manager.configuration.context.aibotAvailable && manager.configuration.context.pageEntry !== "Default") {
    Twilio.FlexWebChat.MessageInput.defaultProps.disabledReason = void 0;
  }
  if ((attr == null ? void 0 : attr.inputTextAllowed) === false) {
    Twilio.FlexWebChat.MessageInput.defaultProps.disabledReason = void 0;
  }
  if (attr) {
    attr.isDisabled = true;
    attr = JSON.stringify(attr).replaceAll("&", "%26");
    await fetchChatMessageAttributes(
      manager.configuration.context.runtimeDomain,
      `channelSid=${payload.channelSid}&messageSid=${payload.messageSid}&attributes=${attr}`
    );
  }
}
async function beforeSendMessage(payload, cancelAction) {
  const { manager } = getChatInstance();
  const { messageAttributes, channel } = payload;
  if (channel.source.channelState.attributes && channel.source.channelState.attributes.status !== "ACTIVE") {
    cancelAction();
  } else {
    if ((messageAttributes == null ? void 0 : messageAttributes.type) && messageAttributes.type === "optionAnswer" && channel.messages[channel.messages.length - 1].source.state.attributes.inputTextAllowed && channel.messages[channel.messages.length - 1].source.state.attributes.inputTextAllowed === true) {
      Twilio.FlexWebChat.MessageInput.defaultProps.disabledReason = void 0;
    }
    if ((messageAttributes == null ? void 0 : messageAttributes.type) && messageAttributes.type === "optionAnswer" && channel.messages[channel.messages.length - 1].source.state.attributes.transferToAgent && channel.messages[channel.messages.length - 1].source.state.attributes.transferToAgent === true) {
      manager.configuration.context.scrollFocusRequired = false;
    }
    if ((messageAttributes == null ? void 0 : messageAttributes.answerKey) === "VEEV") {
      Twilio.FlexWebChat.MessageInput.defaultProps.disabledReason = void 0;
      manager.configuration.context.scrollFocusRequired = false;
    }
  }
}
let localization;
const getAibotLocalisationRequest = async (marketConfig) => {
  const { language, market, runtimeDomain } = marketConfig;
  localization = await fetchAibotLocalization(runtimeDomain, {
    serviceSid: "default",
    mapSid: "ai_bot_localization_data",
    key: `${market}.${language}`
  }).then((resp) => resp.data).catch(() => {
  });
  return localization;
};
const getLivechatLocalisationRequest = async (marketConfig) => {
  const {
    language,
    market,
    runtimeDomain,
    productBrandFamily = "IQOS"
  } = marketConfig;
  localization = await fetchLiveChatLocalization(runtimeDomain, {
    market: market.toUpperCase(),
    language,
    productBrandFamily,
    dynamicItemType: "LIVECHAT"
  }).catch(() => {
  });
  return localization;
};
const getLocalization = async (marketConfig) => {
  if (localization && !(marketConfig == null ? void 0 : marketConfig.noCache)) {
    return localization;
  }
  if (!marketConfig) {
    return null;
  }
  const { liveChatEnabled } = marketConfig;
  if (liveChatEnabled) {
    return getLivechatLocalisationRequest(marketConfig);
  }
  return getAibotLocalisationRequest(marketConfig);
};
const onMessageAdded = async (message) => {
  var _a, _b, _c, _d, _e, _f;
  const { manager } = getChatInstance();
  const localization2 = await getLocalization();
  if (manager.configuration.context.scrollFocusRequired) {
    setTimeout(() => {
      const twilioBubble = document.getElementsByClassName(
        TWILIO_MESSAGE_BUBBLE_CLASSNAME
      );
      const targetBubble = twilioBubble[manager.configuration.context.counterConsumerIndex];
      if (targetBubble) {
        targetBubble == null ? void 0 : targetBubble.scrollIntoView(true);
      }
    }, 200);
  }
  const attachFileButton = (_a = document.getElementsByClassName(
    TWILIO_ATTACH_FILE_BUTTON_CLASSNAME
  )) == null ? void 0 : _a[0];
  if (!manager.configuration.context.attachmentEnabledAfterTransfer && attachFileButton) {
    attachFileButton == null ? void 0 : attachFileButton.setAttribute("disabled", "true");
  }
  (_b = attachFileButton == null ? void 0 : attachFileButton.classList) == null ? void 0 : _b.add("disableAttachmentIcon");
  if ((_c = message.attributes) == null ? void 0 : _c.enableAttachment) {
    attachFileButton == null ? void 0 : attachFileButton.removeAttribute("disabled");
    manager.configuration.context.attachmentEnabledAfterTransfer = true;
  }
  if ((_d = message.attributes) == null ? void 0 : _d.fiveStarsRating) {
    Twilio.FlexWebChat.MessageInput.defaultProps.disabledReason = (localization2 == null ? void 0 : localization2.MessageInputDisabledReason) ? localization2 == null ? void 0 : localization2.MessageInputDisabledReason : "Please select one of the Feedback Rating Stars";
  }
  if (((_e = message.attributes) == null ? void 0 : _e.inputTextAllowed) === false) {
    Twilio.FlexWebChat.MessageInput.defaultProps.disabledReason = (localization2 == null ? void 0 : localization2.MessageInputDisabledReason) ? localization2.MessageInputDisabledReason : "Please select one option.";
  }
  if (((_f = message.attributes) == null ? void 0 : _f.inputTextAllowed) === true) {
    Twilio.FlexWebChat.MessageInput.defaultProps.disabledReason = void 0;
  }
};
const addActions = () => {
  Twilio.FlexWebChat.Actions.addListener(
    "beforeSendMessage",
    beforeSendMessage
  );
  Twilio.FlexWebChat.Actions.addListener("afterSendMessage", afterSendMessage);
  Twilio.FlexWebChat.Actions.addListener("afterToggleChatVisibility", () => {
    var _a, _b;
    const manager = (_a = getChatInstance()) == null ? void 0 : _a.manager;
    if (!manager.configuration.context.attachmentEnabledAfterTransfer && typeof document !== "undefined") {
      const attachFileButton = (_b = document == null ? void 0 : document.getElementsByClassName) == null ? void 0 : _b.call(
        document,
        "Twilio-AttachFileButton"
      )[0];
      attachFileButton == null ? void 0 : attachFileButton.setAttribute("disabled", "true");
    }
    setChatOpen(ChatOpenState.OPEN);
    if (dataLayer) {
      dataLayer.push({
        event: "livechatDisplayed"
      });
    } else {
      logger.info("Live Chat Displayed");
    }
  });
  Twilio.FlexWebChat.Actions.on("afterAttachFile", async (payload) => {
    var _a, _b;
    const manager = (_a = getChatInstance()) == null ? void 0 : _a.manager;
    if (!manager.configuration.context.attachmentEnabledAfterTransfer) {
      await Twilio.FlexWebChat.Actions.invokeAction("DetachFile", {
        file: payload.file,
        channelSid: payload.channelSid
      });
      const attachFileButton = (_b = document == null ? void 0 : document.getElementsByClassName) == null ? void 0 : _b.call(
        document,
        "Twilio-AttachFileButton"
      )[0];
      attachFileButton == null ? void 0 : attachFileButton.setAttribute("disabled", "true");
    }
  });
  Twilio.FlexWebChat.Actions.addListener("afterMinimizeChat", () => {
    setChatOpen(ChatOpenState.CLOSED);
  });
  Twilio.FlexWebChat.Actions.addListener("afterStartEngagement", (payload) => {
    var _a, _b, _c;
    const question = payload;
    const manager = (_a = getChatInstance()) == null ? void 0 : _a.manager;
    if (!question) {
      return;
    }
    if (dataLayer) {
      dataLayer.push({
        event: "livechatWindowLoaded"
      });
    } else {
      logger.info(`Engagement Started: ${payload.formData}`);
    }
    if (manager.configuration.context.counterConsumerIndex > 0 && document.getElementsByClassName(TWILIO_MESSAGE_BUBBLE_CLASSNAME).length === 0) {
      manager.configuration.context.counterConsumerIndex = 0;
      manager.configuration.context.scrollFocusRequired = true;
    }
    (_c = (_b = document.getElementsByClassName(TWILIO_ATTACH_FILE_BUTTON_CLASSNAME)) == null ? void 0 : _b[0]) == null ? void 0 : _c.classList.add("disableAttachmentIcon");
    const channelSession = manager.store.getState().flex.session;
    manager.chatClient.getChannelBySid(channelSession.channelSid).then((channel) => {
      var _a2, _b2;
      if (question.formData !== "undefined") {
        logger.info(
          `Question: ${question} has been sent thru Channel: ${channel.sid}`
        );
        channel.sendMessage(
          (_b2 = (_a2 = manager.store.getState().flex.config) == null ? void 0 : _a2.preEngagementConfig) == null ? void 0 : _b2.submitLabel
        ).catch((err) => {
          logger.error(err);
        });
      }
      channel.on("messageAdded", onMessageAdded);
      manager.configuration.context.proactiveChatInitialized = true;
    }).catch((err) => {
      logger.error(err);
    });
  });
};
const handleRTL = () => {
  const twilioWebChatFrame = document.getElementById("twilio-customer-frame");
  if (twilioWebChatFrame) {
    twilioWebChatFrame.dir = "rtl";
  }
};
function setupWebChat(appConfig, marketConfig, localization2) {
  const { websiteOrigin, isRTL, pageEntry, liveChatEnabled } = marketConfig;
  Twilio.FlexWebChat.FlexWebChat.create(appConfig).then((webchat) => {
    setChatInstance(webchat);
    const { manager } = webchat;
    const newLocalization = addOriginToContent(
      localization2,
      websiteOrigin,
      pageEntry
    );
    addLocalizationToManager(newLocalization);
    addContent();
    addActions();
    if (!liveChatEnabled) {
      Twilio.FlexWebChat.MessagingCanvas.defaultProps.predefinedMessage = void 0;
    }
    webchat.init();
    if (isRTL) {
      handleRTL();
    }
    setTimeout(() => {
      const chatState = manager.store.getState();
      if (chatState.flex.chat.session.connectionState !== "connected") {
        Twilio.FlexWebChat.Actions.invokeAction("ToggleChatVisibility").catch(
          (err) => {
            logger.error(err);
          }
        );
      } else {
        setChatOpen(ChatOpenState.OPEN);
      }
    }, 0);
    if (dataLayer) {
      dataLayer.push({
        event: "livechatClickIcon"
      });
    } else {
      logger.info("Live Chat Icon Clicked");
    }
  }).catch((err) => {
    logger.error("CREATE_WEBCHAT_FAILURE", err);
  });
}
function showWebChat() {
  Twilio.FlexWebChat.Actions.invokeAction("ToggleChatVisibility").catch(
    (err) => {
      logger.error(err);
    }
  );
}
const initialChatState = {
  isInitialised: false,
  isEnabled: false,
  isOpen: false,
  marketConfig: void 0,
  appConfig: void 0,
  localizationContent: void 0,
  manager: void 0,
  isLoading: void 0
};
const useChatState = create((set) => ({
  ...initialChatState,
  setIsEnabled: (isEnabled) => set(() => ({
    isEnabled
  })),
  setIsInitialised: (isInitialised) => set(() => ({
    isInitialised,
    isOpen: true,
    isLoading: false
  })),
  setIsLoading: (isLoading) => set(() => ({
    isLoading
  })),
  setError: (error) => set(() => ({
    error
  })),
  setConfig: (appConfig, marketConfig, localizationContent) => set((state) => ({
    appConfig: { ...state.appConfig ?? {}, ...appConfig },
    marketConfig: { ...state.marketConfig ?? {}, ...marketConfig },
    localizationContent
  }))
}));
const useManageConfig = (config) => {
  const { setConfig, marketConfig, appConfig } = useChatState();
  const { language } = config;
  useEffect(() => {
    const { appConfig: aConfig, marketConfig: mConfig } = getConfig(config);
    setConfig(aConfig, mConfig);
  }, [language]);
  const localizeConfig = useCallback(
    (localization2) => {
      if (appConfig && marketConfig) {
        setConfig(
          mapLocalization(
            marketConfig,
            appConfig,
            localization2
          ),
          marketConfig,
          localization2
        );
      }
    },
    // functions are not valid deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [appConfig, marketConfig]
  );
  return { localizeConfig };
};
const useIsEnabled = () => {
  const { marketConfig, setIsEnabled } = useChatState();
  const checkIsEnabled = useCallback(async () => {
    const { timezone, market, channel, runtimeDomain, liveChatEnabled } = marketConfig;
    if (!liveChatEnabled) {
      setIsEnabled(true);
    } else {
      const fromStorage = getWorkingHoursFromSessionStorage();
      if (!fromStorage) {
        const resp = await fetchOpeningHours(runtimeDomain, {
          timezone,
          market: market.toUpperCase(),
          channel
        }).catch(() => ({ isOpen: false }));
        const { isOpen } = resp;
        setWorkingHoursSessionStorage(resp);
        setIsEnabled(isOpen);
      } else {
        setIsEnabled(fromStorage.isOpen);
      }
    }
  }, [marketConfig, setIsEnabled]);
  useEffect(() => {
    if (marketConfig) {
      checkIsEnabled().finally(() => {
      });
    }
  }, [marketConfig, checkIsEnabled]);
};
const ChatButtonStyles = ".chatbot-button{border-radius:20px;word-break:break-word;width:140px;height:40px;margin:4px 4px 0;font-size:12px;color:#34303d;line-height:1.43;text-align:center;cursor:pointer;border:1.5px solid #272a33}.chatbot-button:hover{background-color:#00d1d2;color:#34303d}.chatbot-button:disabled{opacity:.5;pointer-events:none}.disableAttachmentIcon{pointer-events:none;color:gray!important;cursor:default!important}.enableAttachmentIcon{pointer-events:auto;color:#000!important;cursor:pointer!important}\n";
const StarRatingStyles = '.star-rating{display:flex;align-items:center;width:auto;flex-direction:row-reverse;justify-content:space-between;position:relative;margin:40px auto}.star-rating input{display:none}.star-rating>label{width:30px;height:30px;font-family:Verdana,sans-serif;font-size:30px;color:#000;transition:.2s ease;cursor:pointer}.star-rating label:hover{color:#fff;transition:.2s ease}.star-rating label:active:before{transform:scale(1.1)}.star-rating label:before{content:"☆";position:absolute;top:0;line-height:26px}.star-rating input:checked~label:before{content:"★"}\n';
const RTLStyles = ".Twilio-MainContainer:dir(rtl){right:auto;left:2em}\n";
const styles = [ChatButtonStyles, StarRatingStyles, RTLStyles].join("");
const loadStyle = () => {
  const styleTag = document.createElement("style");
  styleTag.innerHTML = styles;
  document.body.appendChild(styleTag);
};
const useDcxChat = (configOverride) => {
  const {
    isEnabled,
    isLoading,
    appConfig,
    marketConfig,
    setIsInitialised,
    localizationContent,
    isInitialised,
    setIsLoading,
    setError,
    error
  } = useChatState();
  const { isChatOpen } = useSessionStorage();
  const { localizeConfig } = useManageConfig(configOverride);
  useIsEnabled();
  const onClickChatIcon = useCallback(async () => {
    if (isEnabled) {
      try {
        if (!isInitialised) {
          setIsLoading(true);
          const { twilioScript } = marketConfig;
          await loadScript(twilioScript);
          loadStyle();
          const localization2 = await getLocalization(
            marketConfig
          );
          if (localization2) {
            localizeConfig(localization2);
            setIsInitialised(true);
          } else {
            setIsLoading(false);
            setChatOpen(ChatOpenState.CLOSED);
            setError("Failed to get localization data");
            logger.error("Failed to get localization data");
          }
        } else {
          showWebChat();
        }
      } catch (err) {
        setIsLoading(false);
        setChatOpen(ChatOpenState.CLOSED);
        if (typeof err === "string") {
          setError(err);
        }
      }
    }
  }, [appConfig, marketConfig, isEnabled, isInitialised]);
  useEffect(() => {
    if (isChatOpen && isEnabled) {
      onClickChatIcon();
    }
  }, [isChatOpen, isEnabled]);
  useEffect(() => {
    if (isInitialised && appConfig && marketConfig && localizationContent) {
      setupWebChat(appConfig, marketConfig, localizationContent);
    }
  }, [isInitialised, appConfig, marketConfig, localizationContent]);
  return {
    onClickChatIcon,
    isEnabled,
    isLoading,
    isLoaded: isInitialised,
    error
  };
};
export {
  defaultMarketConfig,
  getConfig,
  getTimeZone,
  transformConfig,
  useDcxChat,
  useIsEnabled,
  useManageConfig
};
